import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SX_renderpage_tick } from "../../../assets/icons";
import "./PriceTab.css";
const styles = {
  fontFamily: "Manrope",
  fontWeight: "500",
  fontStyle: "normal",
  textDecoration: "none",
};
const lableStyles = {
  fontFamily: "Manrope",
  fontWeight: "800",
  fontStyle: "normal",
  textDecoration: "none",
};
const currentPlanStyles = {
  fontWeight: "600",
  fontStyle: "normal",
  textDecoration: "none",
};
const upgrdBtnStyle = {
  backgroundColor: "var(--shadePurple100)",
  color: "white",
  borderRadius: ".5rem",
  padding: "4px 22px",
  outline: "1px solid var( --white-20)",
};
const CancelBtnStyle = {
  backgroundColor: "var(--ShadeGray800)",
  color: "white",
  borderRadius: ".5rem",
  padding: "4px 22px",
  outline: "1px solid var( --white-20)",
};

const PlanCubeCard = ({
  iscurrentPlanActivate,
  lable,
  planPurchaseDate,
  currentPlan,
  support,
  rendersLimit,
  projectLimits,
  validity,
  planRenueDate,
  buttonLable,
  onClick,
  paymentType,
  order_id,
  subscription_status,
  expiryString,
  renewalString,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className="flex justify-evenly items-center w-full px-[2%] ">
        <div
          className="h-full w-[45%] flex py-[15px] px-[25px]  flex-col SubBox1 "
          style={{
            border: "1px solid #ffffffcc",
            borderRadius: "1rem",
            color: "#f8f8f6",
          }}
        >
          <div className="w-full  h-[100px] pl-[.25rem]  pr-[10px] flex flex-col justify-evenly">
            <div className="flex items-center">
              <div>
                <p
                  className="lg:text-[1.3rem] text-[0.9rem] mt-[-3px]"
                  style={lableStyles}
                >
                  {lable}
                </p>
              </div>
            </div>

            <div className="">
              <p
                className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
                style={styles}
              >
                {rendersLimit}
              </p>

              <p
                className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
                style={styles}
              >
                {projectLimits}
              </p>
            </div>
          </div>

          <div className="flex justify-between items-center mt-2 h-[40px]">
            <div className="flex items-start p-1 ">
              <button
                className="upgrad_btn manrope-800 sm:text-base flex items-center justify-center px-[12px] py-[4px] bg-[#4e4e4e]"
                style={CancelBtnStyle}
                // onClick={handleCancell}
              >
                <img
                  className="w-4 h-full mr-2"
                  src={SX_renderpage_tick}
                  alt=""
                />
                Current
              </button>
            </div>

            {buttonLable && (
              <div className="flex items-start p-1 ">
                {iscurrentPlanActivate ? (
                  <button
                    className=" manrope-800 upgrad_btn  sm:text-base  px-[22px] py-[4px]"
                    type="submit"
                    onClick={onClick}
                    style={upgrdBtnStyle}
                  >
                    {buttonLable}
                  </button>
                ) : (
                  <button
                    className=" manrope-800 upgrad_btn  sm:text-base  px-[22px] py-[4px]"
                    type="submit"
                    onClick={
                      subscription_status === 2
                        ? onClick
                        : () => navigate("/more_info")
                    }
                    style={upgrdBtnStyle}
                  >
                    {buttonLable}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div
          className="h-full w-[45%] flex jus py-[15px] px-[25px] flex-col SubBox1"
          style={{
            border: "1px solid #ffffffcc",
            borderRadius: "1rem",
            color: "#f8f8f6",
          }}
        >
          <div className="w-full h-[100px] pl-[.25rem]  pr-[10px] flex justify-evenly flex-col">
            <div className="flex items-center">
              <div>
                <p
                  className="lg:text-[1.3rem] text-[0.9rem] mt-[-3px]"
                  style={lableStyles}
                >
                  {`Your Plan Details`}
                </p>
              </div>
            </div>
            <div className="">
              <p
                className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
                style={styles}
              >
                {planPurchaseDate
                  ? `Subscription Purchase ${planPurchaseDate}`
                  : null}
              </p>

              {subscription_status === 2 ? (
                <p
                  className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
                  style={styles}
                >
                  {expiryString}
                </p>
              ) : (
                <p
                  className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
                  style={styles}
                >
                  {renewalString}
                </p>
              )}
            </div>
          </div>

          <div className="flex justify-end  mt-2 h-[40px]">
            <div className="flex items-center p-1 ">
              <button
                className=" manrope-800 sm:text-base px-[22px] py-[4px]"
                style={CancelBtnStyle}
                onClick={() => navigate("/more_info")}
              >
                More Info
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanCubeCard;
